import global from './Globals';

export default {
  loaderSpin: global.primary,
  loaderSpinBg: 'rgba(255, 255, 255, 0.3)',
  loaderTextColour: global.white,
};
